import Vue from 'vue'
import { interactive } from '@common/utils/vnode'
import router from '@/router'
import store from '@store'
import panel from './components/panel.vue'
import _ from 'lodash'

class panelManager {
    $store
    $router
    constructor(router, store) {
        this.$store = store
        this.$router = router
    }
    stack = []
    open (component, propsOrOptions, opts) {
        const me = this
        let props, options
        if (opts) {
            props = propsOrOptions
            options = opts
        } else {
            props = {}
            options = propsOrOptions
        }

        const { width, height, left, top } = options
        const container = document.createElement('div')
        document.body.appendChild(container)
        const { close: closeHandle, ...events } = opts.on || {}
        const panelVm = new Vue({
            el: container,
            data () {
                return {
                    name: options.name,
                    width,
                    height,
                    top,
                    left
                }
            },
            router: this.$router,
            store: this.$store,
            render: h =>
                h(
                    panel, {
                    props: options,
                    on: {
                        close () {
                            panelVm.close()
                        }
                    }
                }, [
                    h(component, {
                        props,
                        on: events
                    })
                ]
                ),
            methods: {
                close () {
                    closeHandle && closeHandle()
                    me.close(this)
                }
            },
            mounted () {
                interactive(this, this.$el.querySelector('.el-card__header'))
            }
        })
        this.stack.push(panelVm)
    }
    /**
     * 关闭指定panel并销毁实例
     * @param nameOrPanelVm
     */
    close (nameOrPanelVm) {
        let name, panelVm, index
        if (_.isString(nameOrPanelVm)) {
            name = nameOrPanelVm
            panelVm = this.stack.find(panel => panel.name === name)
        } else if (nameOrPanelVm instanceof Vue) {
            panelVm = nameOrPanelVm
        }
        if (panelVm) {
            index = this.stack.findIndex(panel => panel === panelVm)
            panelVm.$el.remove()
            panelVm.$destroy()
            this.stack.splice(index, 1)
        }
    }
    /**
     * 关闭所有panel及其实例
     */
    closeAll () {
        const clonedStack = [...this.stack]
        clonedStack.forEach(panel => {
            panel.close()
        })
        clonedStack.length = 0
    }
}

export default function install (vue) {
    const panelVm = new panelManager(router, store)
    vue.prototype.$panel = panelVm
    router.afterEach(() => {
        panelVm.closeAll()
    })
}